import { NextImage } from '@components/nextImage/NextImage';
import { buildAuthorPageLink } from '@utils/link';
import NextLink from 'next/link';
import { ReactElement } from 'react';
import {
  AvatarContainer,
  Container,
  Description,
  DescriptionWrapper,
  Name,
} from './AuthorNote.styles';
import { AuthorNoteProps } from './AuthorNote.types';

export const AuthorNote = ({ id, picture, name, bio, slug }: AuthorNoteProps): ReactElement => {
  return (
    <Container>
      <AvatarContainer>
        {picture && <NextImage src={picture} alt="Picture of the author" layout="fill" />}
      </AvatarContainer>
      <DescriptionWrapper>
        <NextLink href={buildAuthorPageLink(id, slug)} legacyBehavior>
          <Name style={{ cursor: 'pointer' }}>{name}</Name>
        </NextLink>
        <Description>{bio}</Description>
      </DescriptionWrapper>
    </Container>
  );
};
